import { isLoggedIn } from '../../utils/auth'

export default (store) => {
  return ({
    path: 'social-media-engagements/create',
    getComponent(nextState, cb) {
      const Offer = require('./containers').default
      cb(null, Offer)
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/SocialMediaReward/index.js